import { config } from "@/lib/config";
import { Code2 } from "lucide-react";

export function DevModeIndicator() {
  if (!config.devMode) return null;

  return (
    <div className="fixed bottom-4 left-4 z-50 flex items-center gap-2 bg-yellow-500 text-black px-3 py-2 rounded-lg shadow-lg text-sm font-medium">
      <Code2 className="h-4 w-4" />
      <span>Developer Mode</span>
    </div>
  );
}
